export default "__VITE_ASSET__DDh76C5Y__";